// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"6e413a8c187b6b47cdaa","351":"3bda8c3565c4c699f30d","691":"1a25bea418e62a179afa","731":"993c4a38f125551771d3","843":"c0f93556dcfb7263950f"}[chunkId] + ".js";
};